const MyRegistrations = () => {
  return <div>Unified my registrations placeholder</div>
}

export default MyRegistrations
